import { MY_ACCOUNT_ORDER_QUOTES_SETTINGS_PAGE } from "~/utils/url/staticUrls";
import { type TileData } from "~/features/myAccount/dashboard/type";
import { userIsInquirer } from "~/domains/user/utils/roles";

export function getMyCompanyTiles(): TileData[] {
  // According to SCHAEFF-16628 and SCHAEFF-14939, the inquirer should not be able to set CC addresses for order ack
  // Therefore, he needs to see a different translation key, since he can only set quote addresses.
  const isInquirer = userIsInquirer();
  return [
    {
      url: MY_ACCOUNT_ORDER_QUOTES_SETTINGS_PAGE,
      title: `page.accountSettings.section.myCompany.tile.${isInquirer ? "quote" : "orderQuote"}.title`,
      description: `page.accountSettings.section.myCompany.tile.${isInquirer ? "quote" : "orderQuote"}.description`,
      testId: "order-quote-settings-tile",
    },
    // TO BE DEVELOPED in next sprint/s
    // {
    //   url: MY_ACCOUNT_SHIPPING_ADDRESSES_PAGE,
    //   title: "page.accountSettings.section.myCompany.tile.shippingAddress.title",
    //   description: "page.accountSettings.section.myCompany.tile.shippingAddress.description",
    // },
  ];
}
